import { t } from "./i18n";
export const COACH_MODES = [
  { id: "general", label: t("Coach IA"), description: t("Assistant polyvalent pour votre activité.") },
  { id: "business", label: t("Coach Business"), description: t("Stratégie et développement commercial.") },
  { id: "productivite", label: t("Coach Productivité"), description: t("Organisation et priorités.") },
  { id: "finance", label: t("Coach Finance"), description: t("Budget, dépenses et trésorerie.") },
  { id: "marketing", label: t("Coach Marketing"), description: t("Communication et acquisition.") },
  { id: "redaction", label: t("Coach Rédaction"), description: t("Documents et messages professionnels.") },
  { id: "projet", label: t("Coach Projet"), description: t("Tâches, étapes, risques et délais.") },
] as const;

export type CoachMode = (typeof COACH_MODES)[number]["id"];
export const COACH_MODE_IDS = COACH_MODES.map((m) => m.id) as [CoachMode, ...CoachMode[]];

export const PROFILE_TYPES = [
  { id: "freelance", label: t("Freelance") },
  { id: "entrepreneur", label: t("Entrepreneur") },
  { id: "dirigeant", label: t("Dirigeant de TPE/PME") },
  { id: "consultant", label: t("Consultant") },
  { id: "salarie", label: t("Salarié") },
  { id: "porteur_projet", label: t("Porteur de projet") },
] as const;
export type ProfileType = (typeof PROFILE_TYPES)[number]["id"];
export const PROFILE_TYPE_IDS = PROFILE_TYPES.map((p) => p.id) as [ProfileType, ...ProfileType[]];

export const MEMORY_CATEGORIES = [
  { id: "preference_redaction", label: t("Préférence rédactionnelle") },
  { id: "objectif", label: t("Objectif professionnel") },
  { id: "methode", label: t("Méthode de travail") },
  { id: "projet", label: t("Projet actif") },
  { id: "consigne", label: t("Consigne récurrente") },
  { id: "info_metier", label: t("Information métier") },
] as const;
export type MemoryCategory = (typeof MEMORY_CATEGORIES)[number]["id"];
export const MEMORY_CATEGORY_IDS = MEMORY_CATEGORIES.map((m) => m.id) as [MemoryCategory, ...MemoryCategory[]];

export const RESPONSE_STYLES = [
  { id: "concis", label: t("Concis") },
  { id: "equilibre", label: t("Équilibré") },
  { id: "detaille", label: t("Détaillé") },
] as const;
export type ResponseStyle = (typeof RESPONSE_STYLES)[number]["id"];
export const RESPONSE_STYLE_IDS = RESPONSE_STYLES.map((m) => m.id) as [ResponseStyle, ...ResponseStyle[]];

export const SECTORS = [
  t("Conseil & services aux entreprises"),
  t("Commerce & e-commerce"),
  t("Tech & numérique"),
  t("Santé & bien-être"),
  t("BTP & artisanat"),
  t("Hôtellerie & restauration"),
  t("Formation & coaching"),
  t("Création & communication"),
  t("Immobilier"),
  t("Transport & logistique"),
  t("Industrie"),
  t("Associatif"),
  t("Autre"),
];

export const GOAL_OPTIONS = [
  t("Augmenter mon chiffre d'affaires"),
  t("Trouver de nouveaux clients"),
  t("Mieux organiser mon temps"),
  t("Maîtriser ma trésorerie"),
  t("Lancer une nouvelle offre"),
  t("Structurer mon entreprise"),
  t("Recruter / déléguer"),
  t("Réduire mes tâches administratives"),
];

export const CHALLENGE_OPTIONS = [
  t("Manque de temps"),
  t("Trop de tâches administratives"),
  t("Prospection difficile"),
  t("Visibilité sur la trésorerie"),
  t("Difficulté à prioriser"),
  t("Relances clients / impayés"),
  t("Rédaction de documents"),
  t("Isolement dans les décisions"),
];

export const FEATURE_OPTIONS = [
  { id: "coach", label: t("Coach IA") },
  { id: "planning", label: t("Planification & tâches") },
  { id: "finance", label: t("Finances & trésorerie") },
  { id: "documents", label: t("Documents professionnels") },
  { id: "automations", label: t("Automatisations") },
  { id: "goals", label: t("Objectifs & performances") },
  { id: "team", label: t("Travail en équipe") },
];
